export default __webpack_public_path__ + "img/a810c4c33aecd74bdd90b38e1f56fc18.png";